<template lang="pug">
  .select-choice(:class="{ active: opened }" @click="toggleOpened" v-click-outside="hide")
    span(v-if="placeholder && selectedOptions.length == 0") {{ placeholder }}
    ul.select-choice-selected
      li(v-for="option in selectedOptions")
        div {{ option.label }}
        a.select-choice-delete(:data-value="option.value" @click="deleteCode") 削除
    .select-choice-field(v-if="opened")
      label.checkbox(v-for="option in options" @click.stop="")
        input(
          type='checkbox'
          :value="{label: option.label, value: option.value}"
          v-model="selectedOptions")
        span {{ option.label }}
</template>

<script>
  import clickOutside from 'vue-click-outside'

  export default {
    props: ['value', 'options', 'placeholder'],
    data () {
      return {
        opened: false,
        selectedOptions: [],
      }
    },
    directives: {
      clickOutside,
    },
    watch: {
      value (v) {
        this.selectedOptions = v
      },
    },
    computed: {
      isNumber () {
        return this.selectedOptions[0] && typeof this.selectedOptions[0].value === 'number'
      },
    },
    methods: {
      deleteCode (e) {
        e.stopPropagation()
        const value = e.currentTarget.dataset.value
        const code = this.isNumber ? Number(value) : value
        this.selectedOptions = this.selectedOptions.filter(o => o.value !== code)
      },
      hide () {
        if (this.opened) {
          this.opened = false
        }
      },
      toggleOpened () {
        this.opened = !this.opened
      },
    },
    mounted () {
      // https://github.com/vue-bulma/click-outside#example
      this.popupItem = this.$el
      this.selectedOptions = this.value
    },
    updated () {
      this.$emit('input', this.selectedOptions)
    },
  }
</script>



// WEBPACK FOOTER //
// src/components/parts/MultipleSelect.vue